module.exports = __webpack_public_path__ + "assets/media/day2.e0f2aa49.mp3";